import { Icon } from './Icon';

type DashboardPreviewProps = { language: 'ar' | 'en'; mode?: 'hero' | 'showcase' };

export function DashboardPreview({ language, mode = 'hero' }: DashboardPreviewProps) {
  const ar = language === 'ar';
  const labels = {
    dashboard: ar ? 'لوحة التحكم' : 'Dashboard',
    active: ar ? 'حالات نشطة' : 'Active cases',
    ready: ar ? 'جاهزة للتسليم' : 'Ready to deliver',
    due: ar ? 'تحصيل مستحق' : 'Collection due',
    performance: ar ? 'أداء المختبر' : 'Lab performance',
    recent: ar ? 'أحدث التركيبات' : 'Recent cases',
    zircon: ar ? 'زيركون' : 'Zirconia',
    emax: 'E-max',
    metal: ar ? 'معدن بورسلين' : 'PFM',
    production: ar ? 'الإنتاج' : 'Production',
    complete: ar ? 'مكتملة' : 'Completed',
  };

  return (
    <div className={`dashboard-preview dashboard-preview--${mode}`} aria-label={labels.dashboard}>
      <div className="dashboard-preview__chrome">
        <span /><span /><span />
        <strong>{labels.dashboard}</strong>
        <Icon name="search" />
      </div>
      <div className="dashboard-preview__body">
        <aside className="dashboard-preview__rail" aria-hidden="true">
          {['reports', 'tooth', 'invoice', 'inventory', 'team'].map((name, index) => (
            <span className={index === 0 ? 'is-active' : ''} key={name}><Icon name={name} /></span>
          ))}
        </aside>
        <div className="dashboard-preview__content">
          <div className="preview-metrics">
            <article><span><Icon name="tooth" /></span><strong>234</strong><small>{labels.active}</small></article>
            <article><span><Icon name="check" /></span><strong>18</strong><small>{labels.ready}</small></article>
            <article><span><Icon name="invoice" /></span><strong>42.8K</strong><small>{labels.due}</small></article>
          </div>
          <div className="preview-grid">
            <article className="preview-panel preview-chart">
              <header><strong>{labels.performance}</strong><span>+18.4%</span></header>
              <div className="chart-bars" aria-hidden="true">
                {[38, 52, 44, 68, 62, 84, 76, 92].map((height, index) => (
                  <i style={{ height: `${height}%` }} key={index} />
                ))}
              </div>
              <div className="chart-line" aria-hidden="true"><span /><span /><span /><span /><span /><span /></div>
            </article>
            <article className="preview-panel preview-cases">
              <header><strong>{labels.recent}</strong><span><Icon name="arrow" /></span></header>
              {[
                { name: labels.zircon, id: '#DL-2381', tone: 'cyan' },
                { name: labels.emax, id: '#DL-2378', tone: 'violet' },
                { name: labels.metal, id: '#DL-2374', tone: 'gold' },
              ].map((item) => (
                <div className="preview-case" key={item.id}>
                  <span className={`tooth-chip tooth-chip--${item.tone}`}><Icon name="tooth" /></span>
                  <span><strong>{item.name}</strong><small>{item.id}</small></span>
                  <i />
                </div>
              ))}
            </article>
            <article className="preview-panel preview-progress">
              <header><strong>{labels.production}</strong><span>{labels.complete}</span></header>
              <div className="progress-ring"><strong>76%</strong></div>
              <div className="progress-legend"><i /><span>{labels.complete}</span><b>182</b></div>
              <div className="progress-legend is-muted"><i /><span>{labels.active}</span><b>57</b></div>
            </article>
          </div>
        </div>
      </div>
    </div>
  );
}
